module.exports = __webpack_public_path__ + "static/img/20200518-06.fed0301.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/20200518-06.png
// module id = BxnT
// module chunks = 1